/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
var clickedOnce = false, event_passed = 0, first_call = 0;
(async function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch,
      algoliasearch = algolia.externals.algoliasearch,
      searchBox = algolia.externals.widgets.searchBox,
      stats = algolia.externals.widgets.stats,
      sortBy = algolia.externals.widgets.sortBy,
      clearRefinements = algolia.externals.widgets.clearRefinements,
      panel = algolia.externals.widgets.panel,
      hits = algolia.externals.widgets.hits,
      pagination = algolia.externals.widgets.pagination,
      configure = algolia.externals.widgets.configure,
      index_suffix = await algolia.config.index_suffix,
      aa = algolia.externals.aa,
      connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements,
      collectionPageEnabled = algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection;
  
  const capitalizeText = (words) => words.split(" ").map((w) => w.toLowerCase().substring(0, 1).toUpperCase() + w.toLowerCase().substring(1)).join(" ");
  const html = (strings, ...values) => String.raw({ raw: strings }, ...values);
  const GTM_ANALYTICS_ENABLED = true;
  const createDataLayerProduct = (product) => {
      const obj = {
          position: Number(product.__position),
          basePrice: Number(product.price),
          brand: product.vendor,
          category: product.collections,
          hasNoVariants: Number(product.variants_count) > 0 ? false : true,
          id: Number(product.id),
          isInStock: (product.inventory_policy == "continue" || product.inventory_quantity) > 0 ? true : false,
          name: product.title,
          numVariants: Number(product.variants_count),
          price: Number(product.price),
          sku: product.sku,
          stockQty: Number(product.inventory_quantity),
          tags: product.tags,
          type: product.product_type,
          additionalData: {
              barcode: product.barcode,
              body_html_safe: product.body_html_safe,
              brand: product.named_tags_names,
              can_order: product.inventory_policy == "continue" ? true : false,
              collection_ids: product.collection_ids,
              compare_at_price: Number(product.compare_at_price),
              created_at: product.created_at,
              grams: Number(product.grams),
              handle: product.handle,
              id: Number(product.id),
              image: product.image,
              index: product.index,
              inventory_available: product.inventory_available,
              inventory_management: product.inventory_management,
              inventory_management_shopify: Number(product.inventory_management_shopify),
              inventory_policy: product.inventory_policy,
              inventory_quantity: Number(product.inventory_quantity),
              named_tags_names: product.named_tags_names,
              objectID: product.objectID,
              option1: product.option1,
              option2: product.option2,
              option3: product.option3,
              option_names: product.option_names,
              position: Number(product.position),
              price: Number(product.price),
              price_range: product.price_range,
              price_ratio: Number(product.price_ratio),
              productPosition: Number(product.productPosition),
              product_image: product.product_image,
              product_type: product.product_type,
              published_at: product.published_at,
              queryID: product.queryID,
              requires_shipping: Boolean(product.requires_shipping),
              sku: product.sku,
              tags: product.tags,
              taxable: Boolean(product.taxable),
              template_suffix: product.template_suffix,
              title: product.title,
              updated_at: product.updated_at,
              variant_title: product.variant_title,
              variants_count: Number(product.variants_count),
              variants_inventory_count: Number(product.variants_inventory_count),
              variants_max_price: Number(product.variants_max_price),
              variants_min_price: Number(product.variants_min_price),
              vendor: product.vendor,
              weight: product.weight,
          },
      };
      return obj;
  };
  const set_price_op = () => {
    var all_pin = document.querySelectorAll('.ais-current-refined-values--item');
    if(all_pin.length > 0){
     for (i = 0; i < all_pin.length; ++i) {
          if(all_pin[i].querySelector('[data-attribute="price"]') != null){
            var anchore = all_pin[i].querySelector('[data-attribute="price"]');
            var price_num = anchore.getAttribute('data-value');
            if(anchore.getAttribute('data-operator') == '%3C%3D'){
              anchore.setAttribute("data-operator", "<=");
              anchore.setAttribute("data-label", "≤ "+price_num);
            }else if(anchore.getAttribute('data-operator') == '%3E%3D'){
              anchore.setAttribute("data-operator", ">=");
              anchore.setAttribute("data-label", "≥ "+price_num);
            }
          }
      } 
    } else {
      setTimeout(function(){ set_price_op(); },1000);
    }
  }; 
  const set_price_cur = () => {
      var cur_sym = cur_sym = document.createElement("span");
      cur_sym.innerHTML = '$';
      var all_tooltip = document.querySelectorAll('.rheostat-tooltip'), cnt_span = 0,
        all_pin = document.querySelectorAll('.ais-current-refined-values--item');
      for (i = 0; i < all_pin.length; ++i) {
          if(all_pin[i].querySelector('span') == null){
            all_pin[i].insertBefore(cur_sym, all_pin[i].firstChild);
          }
      }
      for (i = 0; i < all_tooltip.length; ++i) {
          if(all_tooltip[i].querySelector('span') == null){ all_tooltip[i].insertBefore(cur_sym, all_tooltip[i].firstChild); }
      }
      for (i = 0; i < all_tooltip.length; ++i) {
          if(all_tooltip[i].querySelector('span') != null){ cnt_span++; }
      }
      if(cnt_span != all_tooltip.length){ set_price_cur(); }
  };
  const set_color_op = () => {
      var all_pin = document.querySelectorAll('.ais-current-refined-values--item');
      if(all_pin.length > 0){
       for (i = 0; i < all_pin.length; ++i) {
          if(all_pin[i].querySelector('[data-attribute="options.color"]') != null){
            var anchore = all_pin[i].querySelector('[data-attribute="options.color"]');
            var color_n = anchore.getAttribute('data-value').toString();
            color_n = color_n.replace('%20', ' ');
            anchore.setAttribute("data-label", color_n);
            anchore.setAttribute("data-value", color_n);
          }
        } 
      } else {
        setTimeout(function(){ set_color_op(); },1000);
      }
  }; 

  function titleCase(str) {
     var splitStr = str.toLowerCase().split(' ');
     for (var i = 0; i < splitStr.length; i++) { // You do not need to check if i is larger than splitStr length, as your for does that for you Assign it back to the array
         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);    
     }
     return splitStr.join(' ');  // Directly return the joined string
  }
  
  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /** * If we aren't on the search page and neither on a collection page, then there's no need to proceed */
    return;
  } else if (algolia.full_results) {
    /*** If we are on the search page and instant search isn't enabled, then there's no need to proceed */
    if (!algolia.config.instant_search_enabled) { return; }
  } else if (algolia.is_collection_results_page) {
    /*** If we are on a collection page and instant search on collection isn't enabled, then there's no need to proceed */
    if (!algolia.config.instant_search_enabled_on_collection) { return; }
  }

  /*** Array which will contain all filters to be applied while initiating the search API call. */
  var searchFilters = [],
      collectionFacetFilter = null,
      collectionRulesContextValue = null,
      collectionHandle = null;
  
  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;
    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id ? 'collection_ids:"' + algolia.current_collection_id + '"' : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }
    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);
    collectionRulesContextValue = algolia.config.collection_id_query_rules ? algolia.current_collection_id : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /** For 'allow', we don't need to add any filter as we want to continue displaying all out of stock items. */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /** For 'continue' we will filter on `inventory_available` attribute whose value is dependent on: `inventory_quantity > 0 OR inventory_policy == 'continue'` */
      stockPolicyFilter = 'inventory_available:true OR named_tags.Algolia:Show';
    }
    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled ? algolia.config.collection_css_selector : algolia.config.results_selector;
  var activeSortOrders = collectionPageEnabled && algolia.collectionSortOrders ? algolia.collectionSortOrders : algolia.sortOrders;
  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /** List of URL params which are "allowed" by InstantSearch. These parameters won't be overwritten when the search state is written to the URL. */
  var ALLOWED_FOREIGN_PARAMS = [ 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'taggEnv', 'taggFakeData' ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /** `stateToRoute` method transforms the `uiState` object from InstantSearch into an object that will then be serialized to construct the URL. */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /** `routeToState` method transforms the route object into a `uiState` object so that InstantSearch is initialized with the correct state from the URL. */
      routeToState: function(routeState) {
        /** Backup parameters from `routeState` into a different object `foreignRouteState` so that we can re-inject them into the object returned within `stateToRoute`. This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS` array. */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden: collectionPageEnabled && algolia.collectionHiddenFacets ? algolia.collectionHiddenFacets : algolia.hiddenFacets,
      shown: collectionPageEnabled && algolia.collectionShownFacets ? algolia.collectionShownFacets : algolia.shownFacets,
      list: collectionPageEnabled && algolia.collectionFacets ? algolia.collectionFacets : algolia.facets,
      widgets: collectionPageEnabled && algolia.collectionFacetsWidgets ? algolia.collectionFacetsWidgets : algolia.facetsWidgets,
    },
    hitsPerPage: collectionPageEnabled && algolia.config.collections_full_results_hits_per_page ? algolia.config.collections_full_results_hits_per_page : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      },
      searchFunction: function(searchFunctionHelper) {
         if (clickedOnce == false) { // Set query parameters here because they're not kept when someone presses the Back button if set in the `init` function of a custom widget
            var page = searchFunctionHelper.getPage();
            
            searchFunctionHelper.setQueryParameter(
              'highlightPreTag', '<span class="ais-highlight">'
            );
            searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
             
            if (instant.distinct) searchFunctionHelper.setQueryParameter('distinct', true);

            // Assign any required filters
            if (searchFilters.length) searchFunctionHelper.setQueryParameter('filters', searchFilters.join(' AND '));

            // Assign any required `ruleContexts` which are required for query rules targeting collection pages
            if (collectionPageEnabled) {
              // Collection page merchandising: If we are on a collection page, `collectionRulesContextValue` is defined
              if (collectionRulesContextValue) {
                // hide sample-sale collections from all other collections
                var rulecontext_val = '';
                if (collectionRulesContextValue.toString() == 'sample-sale'){ rulecontext_val = 'sample-sale'; } else { rulecontext_val = 'hide-sample-sale'; }
                searchFunctionHelper.setQueryParameter("ruleContexts", [
                    collectionRulesContextValue.toString(),
                    collectionRulesContextValue.toString() + "-ads",
                    "bury-sale",
                     rulecontext_val
                ]);
              } else {
                searchFunctionHelper.setQueryParameter('ruleContexts', []);
              }
            } else {
              searchFunctionHelper.setQueryParameter("ruleContexts", ["hide-products", "bury-sale-products","bury-sale"]);
            }

           var source_rule = window.source_rule == [] ? '' : window.source_rule;
            if (source_rule != ''){
              source_rule.forEach(function(x){
                searchFunctionHelper.state.ruleContexts.push(x);  
              });
            }  
           
            searchFunctionHelper.setPage(page);
            searchFunctionHelper.search();
         }
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders
  };
  
  instant.search.client.addAlgoliaAgent('Shopify Integration');
  algolia.instantsearch = instant;
  
  if (instant.poweredBy) { // eslint-disable-next-line no-console
    console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.offsetWidth, suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
      throw new Error('Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector');
    }
  } else if (document.querySelectorAll(algolia.config.results_selector).length === 0) {
    throw new Error('Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector');
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();
  window.addEventListener('resize', function() { readjust(); });

  const QueryRules = algolia.externals.connectors.connectQueryRules;
  const renderQueryRules = (renderOptions, isFirstRender) => {};
  const customQueryRules = QueryRules(renderQueryRules);
  instant.search.addWidgets([
      customQueryRules({
        container: '#redirect',
        templates: {
          default: '',
        },
        transformItems(items) {
          const match = items.find(data => Boolean(data.redirect));
          if (match && match.redirect) {
            window.location.href = match.redirect;
          }
          return [];
        },
     }),
  ]);

  instant.search.addWidgets([ // Collection banners
    {
        init: () => {
            const banners=[
                  {
                    handle:"gifts-100-under",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_UNDER100_GG_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/UNDER100_GG_MOBILE.jpg?v=1698244647".toString(),
                    alt:"gift under 100",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"100-to-150",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_100-150_GG_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/100-150_GG_MOBILE.jpg?v=1698244800".toString(),
                    alt:"100 to 150",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"150-to-200",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_150-200_GG_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/150-200_GG_MOBILE.jpg?v=1698244877".toString(),
                    alt:"150 to 200",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"gifts-200-over",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_OVER200-GG-BANNER_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/OVER200-GG-BANNER_MOBILE.jpg?v=1698245166".toString(),
                    alt:"gifts 200 over",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"winter-ready",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_WINTER-READY_GG_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/WINTER-READY_GG_MOBILE.jpg?v=1698245445".toString(),
                    alt:"winter ready",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"shiny-bright",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_SHINY-GG-BANNER_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/SHINY-GG-BANNER_MOBILE.jpg?v=1698245523".toString(),
                    alt:"shiny bright",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"cozy-vibes",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_COZY-GG-BANNER_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/COZY-GG-BANNER_MOBILE.jpg?v=1698245604".toString(),
                    alt:"cozy vibes",
                    type:"wide",
                    filterOn: false,
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"chic-essentials",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/NEW_CHIC-GG-BANNER_DESK.jpg?v=1698305659".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/CHIC-GG-BANNER_MOBILE.jpg?v=1698245675".toString(),
                    alt:"chic exxentials",
                    filterOn: false,
                    type:"wide",
                    overlay_links: [
                      {
                        link : "/collections/all-gifts",
                        cssDesktop: 'left:0%;top:50%;height:20%;transform:translate(0%, -50%);width:18%;',
                        cssMobile: 'left:0%;top:0%;height:20%;transform:translate(0%, 0%);width:30%;',
                        title: "All-Gifts"
                      }
                    ]
                  },
                  {
                    handle:"wide-widths",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/wide-width-banner-desktop.jpg?v=1691503431".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/wide_widths_mobile.jpg?v=1691503430".toString(),
                    alt:"wide widths",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"wide-calf",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/wide_calf_banner_desktop_2.jpg?v=1691503431".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/wide_calf_mobile.jpg?v=1691503431".toString(),
                    alt:"wide calf",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"extended-sizing",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/extended_sizing_banner_desktop.jpg?v=1691503431".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/extended_sizing_mobile.jpg?v=1691503430".toString(),
                    alt:"extended sizing",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"6-days-of-dolce",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/6-Days_Collection-Banner_Desktop.jpg?v=1700129858".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/6-Days_Collection-Banner_Mobile.jpg?v=1700129858".toString(),
                    alt:"6 days of dolce",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"luxe-gifts",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/DV_Gift-Guide_Collection_Banners_LUXE.jpg?v=1666799712".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/DV_Gift-Guide_Mobile_Collection-Banners_LUXE-2.jpg?v=1666799712".toString(),
                    alt:"luxe gifts",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"all-weather-wishlist",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/Boots_Desktop.jpg?v=1666880207".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/Boots_Mobile.jpg?v=1666880207".toString(),
                    alt:"all weather wishlist",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"forever-favorites",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/Bestsellers_Desktop.jpg?v=1666880207".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/Best-Sellers_Mobile-2.jpg?v=1666880207".toString(),
                    alt:"forever favorites",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"the-pearl-edit",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/pearl_edit_banner.jpg?v=1674059689".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/pearl-edit-mobile-1.jpg?v=1673984333".toString(),
                    alt:"the pearl edit",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"save-the-date",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/new_save_the_date_desktop_1200_x_173_33a523d7-22f4-42d1-a86f-1620d201223d.jpg?v=1678461165".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/save-the-sate-banner_mobile-1.jpg?v=1673984333".toString(),
                    alt:"save the date",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"western-inspired",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/western_banner.jpg?v=1674059689".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/western-inspired-mobile-2.jpg?v=1673984334".toString(),
                    alt:"western inspired",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"raffia-edit",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/new_raffia_banner_desktop.jpg?v=1688562191".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/raffia-edit-banner-mobile-838-335-psd-2_3.jpg?v=1688562191".toString(),
                    alt:"the raffia edit",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"ballet",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/ballet-edit-banner-desktop-2.jpg?v=1684508198".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/ballet-edit-banner-mobile-2.jpg?v=1684508198".toString(),
                    alt:"ballet",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"the-pre-fall-collection",
                    desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/PreFall-Banner_Desktop.jpg?v=1692859067".toString(),
                    mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/prefall-banner-mobile.jpg?v=1692859067".toString(),
                    alt:"the pre fall collection",
                    type:"wide",
                    filterOn: false,
                  },
                  {
                    handle:"shoes-boots-booties",
                    type:"grid",
                    filterOn: true,
                    images:[{
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_3.jpg?v=8665490226003399018".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_3_4fab691b-bcac-4c76-8340-72db6926a8cb.jpg?v=5049399272794041231".toString(),
                      alt:"Knee high",
                      link:"https://www.dolcevita.com/collections/shoes-boots-booties?refinementList%5Bnamed_tags.Style%5D%5B0%5D=KNEE%20HIGH",
                      linkTitle: "Knee high",
                      description: "Step up your style game. Tall boot styles to add a little edge and a lot of polished sophistication."
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_2_5180187c-119f-4a78-82fc-588267120063.jpg?v=409175912553368023".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_2_5f2660e8-c1d6-43c4-8006-cb5b1ac32ae3.jpg?v=5600756029543295278".toString(),
                      alt:"Ankle boots",
                      link:"https://www.dolcevita.com/collections/shoes-boots-booties?refinementList%5Bnamed_tags.Style%5D%5B0%5D=ANKLE",
                      linkTitle: "Ankle boots",
                      description: "Essential ankle boots for everyday, right this way. Explore all of our new favorites."
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_4.jpg?v=62069760169798400".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_4.jpg?v=2366463648690426228".toString(),
                      alt:"Western",
                      link:"https://www.stevemadden.com/collections/boots-booties?refinementList%5Bnamed_tags.Style%5D%5B0%5D=WESTERN",
                      linkTitle: "Western",
                      description: "Best in western. Go full blown wild, wild, west with our latest collection."
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_1.jpg?v=2070420326997753231".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_1_33e9fb19-4c9c-456e-85df-294bb1775e7b.jpg?v=4313394971128087367".toString(),
                      alt:"Waterproof",
                      link:"https://www.dolcevita.com/collections/shoes-boots-booties?refinementList%5Bnamed_tags.Style%5D%5B0%5D=WATERPROOF",
                      linkTitle: "Waterproof",
                      description: "Rain or shine, we’ve got you covered. Discover these on-trend waterproof styles that are ready for anything."
                    }]
                  },
                  {
                    handle:"handbags",
                    type:"grid",
                    filterOn: true,
                    images:[{
                      desktop:"//www.dolcevita.com/cdn/shop/files/12_36d0294a-aab4-4fbc-a5c4-0e818bdcdc15.jpg?v=14488606298716595394".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_10_56d71e29-793b-4ddf-9b59-0aeeb969a78a.jpg?v=15827396807103232681".toString(),
                      alt:"Crossbody",
                      link:"https://www.dolcevita.com/collections/handbags?refinementList%5Bnamed_tags.Style%5D%5B0%5D=CROSSBODY",
                      linkTitle: "Crossbody"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_7.jpg?v=14292158448053760450".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_7.jpg?v=18187559024799362055".toString(),
                      alt:"Shoulder",
                      link:"https://www.dolcevita.com/collections/handbags?refinementList%5Bnamed_tags.Style%5D%5B0%5D=SHOULDER",
                      linkTitle: "Shoulder"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Desktop_5.jpg?v=9989393199359438153".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_5.jpg?v=8027251450621540004".toString(),
                      alt:"Tote",
                      link:"https://www.dolcevita.com/collections/handbags?refinementList%5Bnamed_tags.Style%5D%5B0%5D=TOTE",
                      linkTitle: "Tote"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/11_156caf0b-cb60-47a7-9ed3-c6f7eccaa359.jpg?v=6863148193591968977".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Mobile_9.jpg?v=14020820482447808333".toString(),
                      alt:"mini bags",
                      link:"https://www.dolcevita.com/collections/handbags?refinementList%5Bnamed_tags.Style%5D%5B0%5D=MINI",
                      linkTitle: "mini bags"
                    }]
                  },
                  {
                    handle:"all-gifts",
                    type:"grid",
                    filterOn: false,
                    images:[{
                      desktop:"//www.dolcevita.com/cdn/shop/files/Waterproof_b252e65a-3ece-4550-a74c-9c736e69deaf.jpg?v=12155700951575504780".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Waterproof_b252e65a-3ece-4550-a74c-9c736e69deaf.jpg?v=12155700951575504780".toString(),
                      alt:"Winter Ready",
                      // link:"https://www.dolcevita.com/collections/all-gifts?refinementList%5Bnamed_tags.Gifts%5D%5B0%5D=WATERPROOF",
                      link:"/collections/winter-ready",
                      linkTitle: "Winter Ready"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Metallics.jpg?v=10447844150953461906".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Metallics.jpg?v=10447844150953461906".toString(),
                      alt:"Shiny & Bright",
                      // link:"https://www.dolcevita.com/collections/all-gifts?refinementList%5Bnamed_tags.Gifts%5D%5B0%5D=HOLIDAY%20DRESSING",
                      link:"/collections/shiny-bright",
                      linkTitle: "Shiny & Bright"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Cozy.jpg?v=8850650071644313778".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Cozy.jpg?v=8850650071644313778".toString(),
                      alt:"Cozy Vibes",
                      // link:"https://www.dolcevita.com/collections/all-gifts?refinementList%5Bnamed_tags.Gifts%5D%5B0%5D=COZY",
                      link:"/collections/cozy-vibes",
                      linkTitle: "Cozy Vibes"
                    },
                    {
                      desktop:"//www.dolcevita.com/cdn/shop/files/Handbags_faa869c1-d60b-461f-8888-6076891f04ed.jpg?v=7593341446710096867".toString(),
                      mobile:"//www.dolcevita.com/cdn/shop/files/Handbags_faa869c1-d60b-461f-8888-6076891f04ed.jpg?v=7593341446710096867".toString(),
                      alt:"Chic Essentials",
                      // link:"https://www.dolcevita.com/collections/all-gifts?refinementList%5Bnamed_tags.Gifts%5D%5B0%5D=HANDBAGS",
                      link:"/collections/chic-essentials",
                      linkTitle: "Chic Essentials"
                    }]
                  }
                  // ,{
                  //   handle:"the-private-sale-sms",
                  //   desktop:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/private_sale_banner_desktop.jpg?v=1689304826".toString(),
                  //   mobile:"https://cdn.shopify.com/s/files/1/0037/3807/5202/files/private_sale_banner_mobile.jpg?v=1689304825".toString(),
                  //   alt:"ballet",
                  //   type:"wide"
                  // }
                ];
            const isSearch = ~window.location.href.indexOf("/search");
            const isCollection = ~window.location.href.indexOf("/collection");
            if (isSearch || isCollection) {
					const container = document.querySelector(".ais-banners");
					const bannerVersions = (banner) => {
						if (banner.desktop && banner.mobile) return "both";
						if (banner.desktop) return "desktop";
						if (banner.mobile) return "mobile";
						return false;
					}; 
                    var banner_index = window.location.href.indexOf("/collections/all-gifts") ? 1 : 0;  
                    function setAttributes(el, attrs) {
                      for(var key in attrs) {
                        el.setAttribute(key, attrs[key]);
                      }
                    }
					const renderBanners = (handle, banner, container, version, grid, filterOn) => {
                      if(handle == 'WOMENS-SANDALS'){
                        container.classList.add('sandal-banner-test');
                        container.style.display = "none";
                      } 
                      if(handle == 'THE-PRIVATE-SALE-SMS'){
                        container.classList.add('sticky-banner'); // sticky banner
                      }
                        var banner_unique_class = banner.alt ? banner.alt : handle.replaceAll("-", " ") + " " + type.toUpperCase() + " BANNER";
						const item = {
							element: document.createElement("div"),
							class: grid ? "ais-banner--grid-item" : "ais-banner--wide",
						};
						const imgNo = version == "both" ? 2 : 1;
						const images = [];
						item.element.classList.add(item.class);
						for (let i = 0; i < imgNo; i++) {
							let type = i == 0 ? "desktop" : "mobile";
							let img = {
								element: document.createElement("img"),
								class: type == "desktop" ? "mobile" : "desktop",
							};
							if (imgNo == 1) type = version;
							if (imgNo == 2) img.element.classList.add(img.class + "-hidden");
							img.element.src = banner?.[type];
							img.element.alt = banner.alt ? banner.alt : handle.replaceAll("-", " ") + " " + type.toUpperCase() + " BANNER";
                            images.push(img.element);
						}
						if (banner.link) {
                            const title = banner.linkTitle ? banner.linkTitle : banner.link.split("/").pop().split("?")[0];
							const link = document.createElement("a");
							link.href = banner.link;
							link.title = title.replaceAll("-", " ").toUpperCase();
							if (imgNo == 2) {
								link.append(images[0]);
								link.append(images[1]);
							} else {
								link.append(images[0]);
							}
							item.element.append(link);
						} else {
							if (imgNo == 2) {
								item.element.append(images[0]);
								item.element.append(images[1]);
							} else {
								item.element.append(images[0]);
							}
						}
                        if (banner.linkTitle != undefined){
                            const title = banner.linkTitle ? banner.linkTitle : banner.link ? banner.link.split("/").pop().split("?")[0] : '';
                            const title_link = document.createElement("a");
                            title_link.href = banner.link ? banner.link : '#';
                            title_link.title = title.replaceAll("-", " ").toUpperCase();
                            title_link.innerHTML = title;
                            title_link.classList.add('ais-banner--title');
                            item.element.append(title_link);
                        }
                        if (banner.description){
                          const link_desc = document.createElement("p");
                          link_desc.innerHTML = banner.description;
                          item.element.append(link_desc);
                        }
						if (grid) {
                            banner_index += 1;
							grid.append(item.element);
							container.append(grid);
                              if (filterOn) {
                                container.classList.add('mobile_scroll')
                                container.classList.add('sandal-banner-test');
                              }
                              setAttributes(item.element, { // adding banner attributes
                                'data-promotion-creative_name': banner_unique_class,
                                'data-promotion-name': handle + ' collection page '+ banner_index + (banner_index == 1 ? 'st' :
                                                                                                           banner_index == 2 ? 'nd' :
                                                                                                           banner_index == 3 ? 'rd' :
                                                                                                          'th') + ' banner',
                                'data-promotion-position': handle,
                                'data-promotion-id': banner.desktop,
                                'data-promotion-type': 'gtm-banner',
                                'data-promotion-index': banner_index
                              }); 
						} else {
                          if (handle == 'THE-PRIVATE-SALE-SMS' && window.location.href.indexOf('utm_medium=email') > -1 || handle == 'THE-PRIVATE-SALE-SMS' && window.location.href.indexOf('utm_medium=sms') > -1){
                            container.append(item.element);
                          } else if (handle != 'THE-PRIVATE-SALE-SMS') {
                            container.append(item.element);
                          }
						}
                        if (banner.overlay_links) {
                          container.classList.add('overlay_link_active');
                          banner.overlay_links.forEach((overlayLink) => {
                            const overlaylink = document.createElement("a");
                            overlaylink.classList.add('overlay_link')
							overlaylink.href = overlayLink.link;
							overlaylink.title = overlayLink.title ? overlayLink.title.replaceAll("-", " ").toUpperCase() : '';
                            overlaylink.setAttribute('data-promotion-button', 'ALL GIFTS');
                            var styleCSS = screen.width > 767 ? overlayLink.cssDesktop : overlayLink.cssMobile;
                            setAttributes(overlaylink, {
                              role : 'button',
                              style : styleCSS
                            });
                            container.append(overlaylink);
                          });
                        }
						if(handle == 'WOMENS-SANDALS'){
                          window.dataLayer = window.dataLayer || [];
                          window.dataLayer.push({'event':'optimize.activate'});
                        }
					};
					const wideBanner = (banner) => {
						const version = bannerVersions(banner), filterOn = banner.filterOn;
						renderBanners(handle, banner, container, version, filterOn);
					};
					const gridBanner = (banner) => {
						if (banner?.images.length > 0) {
							const grid = document.createElement("div"), filterOn = banner.filterOn;
							grid.classList.add("ais-banner--grid");
							banner.images.forEach((image) => {
								const version = bannerVersions(image);
								renderBanners(handle, image, container, version, grid, filterOn);
							});
                          // if (filterOn) { 
                          //   container.insertAdjacentHTML("afterend", '<hr>');
                          // };
                        }
					};
					let handle = "";
					if (isCollection) handle = window.location.href.split("/").pop().split("?")[0].toUpperCase();
					if (isSearch) handle = window.location.href.split("?q=").pop().split("&")[0].toUpperCase();
					container.innerHTML = "";
					banners.forEach((banner) => {
						const value = banner.handle ? banner.handle.toUpperCase() : banner.search.toUpperCase();
                        if(handle.indexOf('+') != -1){ handle = handle.replace('+','%20'); }
						if (value == handle) {
							switch (banner.type) {
								case "wide":
									wideBanner(banner);
									break;
								case "grid":
									gridBanner(banner);
									break;
								default:
									break;
							}
						}
					});
				}
        },
    },
  ]); // coll banner
  
  instant.search.addWidgets([ // Mobile facets display
    {
      init: function() {
        // var $button = document.querySelector('.ais-facets-button');
        // $button.addEventListener('click', function() {
        //   var $facets = document.querySelector('.ais-facets');

        //   if ($facets.classList.contains('ais-facets__shown')) {
        //     $button.textContent = 'Show filters';
        //     $facets.classList.remove('ais-facets__shown');
        //   } else {
        //     $button.textContent = 'Hide filters';
        //     $facets.classList.add('ais-facets__shown');
        //   }
        // });
        const header = document.querySelector(".main-ais-search-header");
        const header_height = document.querySelector('#shopify-section-header-new').offsetHeight;
        if (document.querySelector('.sticky-banner') == undefined) { $('.ais-search-header:not(".ais-view-wrap")').css("top",header_height); } // sticky banner
        var $facets = document.querySelector('.ais-facets'),
          $button = document.querySelector('.mobile_filter_btn'),
          custom_clear = document.querySelector(".ais_filter.clear");
          $button.addEventListener('click', function() {
            $facets.classList.toggle("mobile_filter_open");
            document.body.classList.toggle('new-mob-filter-open');
            $button.classList.toggle("mobile_filter_active_btn");
            clickedOnce = true;
            document.querySelectorAll(".ais-RefinementList-showMore").forEach((el) => {
              if (el.textContent == '+ Show more' || el.textContent == 'Show more' ) el.click();
            });
            // HIDE BANNER WHEN FILTER OPEN
            if (document.querySelector('.ais-banners div') && window.innerWidth <= 768 && document.querySelector('.ais-facets').classList.contains('mobile_filter_open')) {
              // var tt = document.querySelector('.ais-facets').offsetTop + 10 + 'px';
              // document.querySelector('.ais-facets.mobile_filter_open').style.setProperty('height', 'calc(100vh - '+ tt +')');
              
              document.querySelector('.ais-banners').style.display = 'none';
              if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'none';
            } else {
              if (document.querySelector('.ais-banners div')){
                document.querySelector('.ais-banners').style.display = 'block';
                if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'block';
                if ($('.sandal-banner-test:not(.gift_guide_banner) .ais-banner--grid').hasClass('slick-initialized')) $('.sandal-banner-test .ais-banner--grid').slick('refresh');
              }
            } // HIDE BANNER WHEN FILTER OPEN
            if(document.querySelectorAll('.mobile_view_btn.ais-mobile--view-btn-selected').length > 0){
              document.querySelector('.mobile_view_btn.ais-mobile--view-btn-selected').classList.remove('ais-mobile--view-btn-selected');
              document.querySelector('.ais-view-wrap.ais-view-selected').classList.remove('ais-view-selected');
            }
          });
        
        if (document.querySelector(".ais_filter.clear")){
          custom_clear.addEventListener("click", function (event) {
          clickedOnce = false;
            document.querySelector(".ais-ClearRefinements-button").click();
            if(screen.width <= 829){
              document.body.classList.remove('new-mob-filter-open');
              $facets.classList.remove("mobile_filter_open");
              $button.classList.remove("mobile_filter_active_btn");

              // HIDE BANNER WHEN FILTER OPEN
              if (document.querySelector('.ais-banners div') && window.innerWidth <= 768 && document.querySelector('.ais-facets').classList.contains('mobile_filter_open')) {
                document.querySelector('.ais-banners').style.display = 'none';
                if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'none';
              } else {
                if (document.querySelector('.ais-banners div')){
                  document.querySelector('.ais-banners').style.display = 'block';
                  if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'block';
                  if ($('.sandal-banner-test:not(.gift_guide_banner) .ais-banner--grid').hasClass('slick-initialized')) $('.sandal-banner-test .ais-banner--grid').slick('refresh');
                }
              } // HIDE BANNER WHEN FILTER OPEN
            }
          });
        }
        $('body').on('keydown','.ais-RefinementList-showMore',function(e){ // Accessibility
          var li_node = $(this).parents('.ais-facet').find('.ais-RefinementList-list li').length + 1;
          if($(e.target).hasClass('ais-RefinementList-showMore') && $(e.target).text() == '+ Show more' ){
            if (e.keyCode == 13){
              setTimeout(function(){
                $(e.target).blur();
                $(e.target).prev('.ais-RefinementList-list').find('li:nth-child('+li_node+') input').focus();
              },500);
            }
          }
        });
        $(window).scroll(function() { // sticky banner
          var yourHeader = $('.shopify-section-header').height();
          if ($('.ais-search-header').length > 0 && document.querySelector('.ais-banners.sticky-banner img') && $(this).scrollTop() > yourHeader){
            $('.ais-banners.sticky-banner').css("top",document.querySelector('#header-main-new').offsetHeight);
            $('.ais-banners.sticky-banner img').css("margin-top","0");
            
            const new_height = document.querySelector('.ais-banners.sticky-banner').offsetHeight + document.querySelector('#header-main-new').offsetHeight;
            $('.ais-search-header:not(".ais-view-wrap")').css("top",new_height);
          } else {
            $('.ais-banners.sticky-banner img').css("margin-top","20px");
          }
        }); // sticky banner
      },
    },
  ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);
  
  instant.search.addWidgets([ // Search input
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);
  
  instant.search.addWidgets([ // Logo & clear
    {
      init: function(opts) {
        document.querySelector('.ais-clear-input-icon').addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display = 'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);
  
  instant.search.addWidgets([ // Stats
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, {html}){
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);

  instant.search.addWidgets([ // Mobile Stats
    stats({
      container: '.mobile_results_count',
      templates: {
        text(data, {html}){
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);
  
  if (activeSortOrders.length > 1) { // Sort orders
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);

    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-containerr',
        items: instant.sortOrders,
      }),
    ]);
  }
  
  instant.search.addWidgets([ // Change display
    {
      init: function() {
        document.querySelector('.ais-search-header .ais-change-display-block').addEventListener('click', function() {
          document.querySelector('.ais-change-display-block:not(.ais-change-display-selected)').classList.add('ais-change-display-selected');
          document.querySelector('.ais-change-display-list.ais-change-display-selected').classList.remove('ais-change-display-selected');
          document.querySelector('.ais-results-as-list').classList.replace('ais-results-as-list', 'ais-results-as-block');
        });
        document.querySelector('.ais-search-header .ais-change-display-list').addEventListener('click', function() {
          document.querySelector('.ais-change-display-list:not(.ais-change-display-selected)').classList.add('ais-change-display-selected');
          document.querySelector('.ais-change-display-block.ais-change-display-selected').classList.remove('ais-change-display-selected');
          document.querySelector('.ais-results-as-block').classList.replace('ais-results-as-block', 'ais-results-as-list');
        });

        document.querySelector('.mobile_view_btn').addEventListener('click', function() { // Change view
          document.querySelector('.ais-view-wrap').classList.toggle('ais-view-selected');
          document.querySelector('.mobile_view_btn').classList.toggle('ais-mobile--view-btn-selected');
          if(document.querySelectorAll('.ais-facets.mobile_filter_open').length > 0){
            document.body.classList.remove('new-mob-filter-open');
            document.querySelector('.ais-facets.mobile_filter_open').classList.remove('mobile_filter_open');
            document.querySelector('.mobile_filter_btn.mobile_filter_active_btn').classList.remove('mobile_filter_active_btn');
          }
        });
        
        const facetsH = document.querySelectorAll(".ais-facet--header"); // Facets toggle
        facetsH.forEach((facet) => {
          if (!Array.from(facet.classList).find((x) => x == "ais-current-refined-values--header")) {
            const facetCallback = (event) => {
              event.stopPropagation();
              facet.classList.toggle("body-hidden");
            };
            if (!Array.from(facet.classList).find((x) => x == "added-listeners")) {
              facet.addEventListener("click", facetCallback);
              facet.classList.add("added-listeners");
            } else {
              facet.removeEventListener("click", facetCallback);
              facet.classList.remove("added-listeners");
            }
          }
        }); // Facets toggle

        $('body').on('click','.ais-Pagination-item',function(){ // #103: It is not clear to screen reader users which pagination link represents the currently active page.
          // hitsWithAds(hits);
          setTimeout(function(){
           $('.ais-Pagination-item').each(function(i,ele){
             if ($(ele).hasClass('ais-Pagination-item--selected')){
               $('.ais-Pagination-item').removeAttr('aria-current');
               $(ele).attr('aria-current','page');
             }
           })
          },5000);
        });
    
        function paginationLinks(){
          if ($('.ais-Pagination-item').length != 0){
             $('.ais-Pagination-item').each(function(i,ele){
               if ($(ele).hasClass('ais-Pagination-item--selected')){
                 $('.ais-Pagination-item').removeAttr('aria-current');
                 $(ele).attr('aria-current','page');
               }
             })
           } else {
            setTimeout(paginationLinks,100);
           }
        }
        paginationLinks(); // #103: It is not clear to screen reader users which pagination link represents the currently active page.

        const button = document.querySelector(".desktop_filter_btn"); // Desktop facets display
        const text = button.querySelector("span");
        const facets = document.querySelector(".ais-facets");
        const results = document.querySelector(".ais-page .ais-block");
        const query = document.querySelector(".ais-search-query");
        const btnCallback = () => {
          if (Array.from(facets.classList).find((x) => x == "hide")) {
            setTimeout(() => {
              facets.classList.toggle("hide");
            }, 300);
          } else {
            facets.classList.toggle("hide");
          }
          if (text.innerHTML == "Hide Filters") {
            text.innerHTML = "Show Filters";
            button.classList.add("filter_hidden");
            results.classList.remove("filter_block_shown");
          } else {
            text.innerHTML = "Hide Filters";
              button.classList.remove("filter_hidden");
              results.classList.add("filter_block_shown");
            setTimeout(() => {
              facets.removeAttribute("style");
            }, 300);
          }
        };
        button.addEventListener("click", btnCallback);
        // banner click event
        // $('body').on("click",".sandal-banner-test .ais-banner--grid-item .ais-banner--title",function(e) {
        //   e.preventDefault();
        //   $(this).parent('.ais-banner--grid-item > a').click();
        // });
        // $('body').on("click",".sandal-banner-test .ais-banner--grid-item > a.active",function(e) {
        //   e.preventDefault();
        //   var _this = $(this), elements = '[class*=ais-facet-named_tags]', id = $(this).attr("href").split('?')[1];
        //   _this.removeClass('active');
        //   if ($(elements).find('.ais-RefinementList-showMore').html().indexOf('Show more') > -1) $(elements).find('.ais-RefinementList-showMore').click();
        //   id = decodeURI(id);
        //   var ids = id.split('&');
        //   $(elements).find('.ais-RefinementList-item--selected input[type="checkbox"]:checked').click();
        //   window.scroll({
        //    top: $('.ais-search-header:not(".ais-view-wrap")').offset().top, 
        //    left: 0, 
        //    behavior: 'smooth' 
        //   });
        // });
        // $('body').on("click",".sandal-banner-test .ais-banner--grid-item a:not(.active)",function(e){
        //   e.preventDefault();
        //   var _this = $(this), elements = '[class*=ais-facet-named_tags]', all_elements = '.ais-RefinementList.ais-facet',id = $(this).attr("href").split('?')[1];
        //   $('.sandal-banner-test .ais-banner--grid-item a').removeClass('active');
        //   _this.addClass('active');
        //   if ($(elements).find('.ais-RefinementList-showMore').html().indexOf('Show more') > -1) {
        //     $(elements).find('.ais-RefinementList-showMore').click();
        //   }
        //   id = decodeURI(id);
        //   var ids = id.split('&');
        //   $.each(ids,function(index, val) {
        //     var id_this = decodeURIComponent(val.split("=")[1]); 
        //     if (!$('[id*="'+id_this+'"]').closest('.ais-RefinementList-item').hasClass('ais-RefinementList-item--selected')){
        //       $(all_elements).find('.ais-RefinementList-item--selected input[type="checkbox"]:checked').click();
        //     } else if ($('[id*="'+id_this+'"]').length == 0) {
        //       $(all_elements).find('.ais-RefinementList-item--selected input[type="checkbox"]:checked').click();
        //     }
        //   });
          
        //   $.each(ids,function(index, val) {
        //     var id_this = decodeURIComponent(val.split("=")[1]),
        //         name = val.split("=")[0].replace('refinementList[', '').replace(']['+index+']', ''),
        //         cls = '.ais-facet-'+name.replace('.', '\\.');
        //     function hello() {
        //       if ($(cls).find('[id*="'+id_this+'"]').length > 0 && window.location.href.indexOf('refinementList') == -1) {
        //         $(cls).find('[id*="'+id_this+'"]').click();
        //       } else {
        //         setTimeout(function() { hello(); }, 1000)
        //       }
        //     }
        //     hello();
        //   });
        //   window.scroll({
        //    top: $('.ais-search-header:not(".ais-view-wrap")').offset().top, 
        //    left: 0, 
        //    behavior: 'smooth' 
        //   });
        // });

        function scrollToProduct(){
          setTimeout(function(){
            window.scroll({
             top: $('.ais-search-header').offset().top, 
             left: 0, 
             behavior: 'smooth' 
            });
          }, 400);
        }
              
        $('body').on("click",".sandal-banner-test .ais-banner--grid-item .ais-banner--title",function(e) {
          e.preventDefault();
          $(this).parent('.ais-banner--grid-item > a').trigger('click');
        });
        
        $('body').on("click",".sandal-banner-test .ais-banner--grid-item > a.active",function(e) {
          e.preventDefault();
          var _this = $(this)
          _this.removeClass('active');
          document.querySelector(".ais-ClearRefinements-button").click();
          scrollToProduct();
        });
        
        $('body').on("click",".sandal-banner-test .ais-banner--grid-item > a:not(.active)",function(e){
          e.preventDefault();
          var _this = $(this);
          $('.sandal-banner-test .ais-banner--grid-item > a').removeClass('active');
          _this.addClass('active');
          var elements = '[class*=ais-facet-named_tags]', all_elements = '.ais-RefinementList.ais-facet';
          if ($(elements).find('.ais-RefinementList-showMore').html().indexOf('Show more') > -1) {
            $(elements).find('.ais-RefinementList-showMore').click();
          }
          document.querySelector(".ais-ClearRefinements-button").click();
          
          var id = $(this).attr("href").split('?')[1];
          id = decodeURI(id);
          var ids = id.split('&');
          
          $.each(ids,function(index, val) {
            var id_this = decodeURIComponent(val.split("=")[1]); 
            var name = val.split("=")[0].replace('refinementList[', '').replace(']['+index+']', '');
            var cls = '.ais-facet-'+name.replace('.', '\\.');
            function hello() {
              if ($(cls).find('[id*="'+id_this+'"]').length > 0 && window.location.href.indexOf('refinementList') == -1) {
                $(cls).find('[id*="'+id_this+'"]').click();
              } else {
                setTimeout(function() { hello(); }, 1000)
              }
            }
            hello();
          });
          scrollToProduct();
        });
            
        // banner click event
        if($('.ais-banners.mobile_scroll:not(.gift_guide_banner) .ais-banner--grid').length > 0){
          $('.ais-banners.mobile_scroll:not(.gift_guide_banner) .ais-banner--grid').slick({
            arrows: true,
            dots: false,
            infinite: true,
            initialSlide: 0,
            slidesToScroll: 1,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll:1
                }
              }
            ]
          });
        } // Desktop facets display
      },
    },
  ]);
  
  var list = instant.facets.hidden.map(function(facet) { // Hidden facets
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);
  
  var createDataAttributes = function(refinement) { // Create the render function
    return Object.keys(refinement).map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      }).join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements.map(function(refinement) {
        return ('<li class="ais-current-refined-values--item"><a ' + createDataAttributes(refinement) + 'class="ais-current-refined-values--link"><div><div class="ais-current-refined-values--label">' + facet.title + '</div>: ' + refinement.label + '</div></a></li>');
      }).join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items, 
        refine = renderOptions.refine,
        widgetParams = renderOptions.widgetParams, 
        all_ul_content = items.map(renderListItem).join("");
    
    if (window.location.href.indexOf("/collections/re-vita") === -1) items = items.filter((item) => item.tags?.find((x) => x === "used") === undefined);

    if(all_ul_content == ''){
      widgetParams.container.innerHTML = '';
      document.querySelector(".ais-clear-refinements-container").style.display = "none";
    } else {
      widgetParams.container.innerHTML = '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div><div class="ais-root ais-current-refined-values ais-facet"><ul class="ais-current-refined-values--list">' + all_ul_content + '</ul></div>';
      document.querySelector(".ais-clear-refinements-container").style.display = "block";
    }
    
    const refinedValues = widgetParams.container.querySelectorAll(".ais-current-refined-values--link");
    Array.prototype.slice.call(refinedValues).forEach(function (element) {
        element.addEventListener("click", function (event) {
            clickedOnce = false;
            if (refinedValues.length == 1) {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setTimeout(() => {
                    document.querySelector(".ais-ClearRefinements-button").click();
                    if(screen.width <= 991) document.body.classList.add('new-mob-filter-open');
                }, 500);
            } else {
                let item = Object.keys(event.currentTarget.dataset).reduce(function (acc, key) {
                    var itemData = {};
                    itemData[key] = event.currentTarget.dataset[key];
                    return algolia.assign({}, acc, itemData);
                }, {});
                refine(item);
            }
            if(screen.width <= 991){
                var $facets = document.querySelector(".ais-facets");
                $facets.classList.remove("ais-facets__shown");
                document.body.classList.add('new-mob-filter-open');
            }
        });
    });
    var apply_btn = document.querySelector(".ais_filter.apply");
    apply_btn.addEventListener("click", function () { 
      clickedOnce = false;
      var $facets = document.querySelector(".ais-facets"), 
          $button = document.querySelector('.mobile_filter_btn'), selected_review = document.querySelector('.selected_review'), pass_value = 'all';
      
      $facets.classList.remove("mobile_filter_open");
      document.body.classList.remove('new-mob-filter-open');
      $button.classList.remove("mobile_filter_active_btn");

      // HIDE BANNER WHEN FILTER OPEN 
      if (document.querySelector('.ais-banners div') && window.innerWidth <= 768 && document.querySelector('.ais-facets').classList.contains('mobile_filter_open')) {
        document.querySelector('.ais-banners').style.display = 'none';
        if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'none';
      } else {
        if (document.querySelector('.ais-banners div')){
          document.querySelector('.ais-banners').style.display = 'block';
          if (document.querySelector('.ais-banners_title')) document.querySelector('.ais-banners_title').style.display = 'block';
          if ($('.sandal-banner-test:not(.gift_guide_banner) .ais-banner--grid').hasClass('slick-initialized')) $('.sandal-banner-test .ais-banner--grid').slick('refresh');
        }
      } // HIDE BANNER WHEN FILTER OPEN
        
      if(selected_review !== 'undefined' && selected_review != null){
        pass_value = document.querySelector('.selected_review').getAttribute('data-value');
        clickedOnce = true;
        refine(pass_value);
        
        setTimeout(function(){
          clickedOnce = false;
          refine(pass_value);
        },1000);
      }else{
        refine(pass_value);
      }
    });
    set_price_op();
  };
  var customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements); // Create the custom widget
  
  let finalHitsRender;  // Infinite hits
  let previousHitsRender;
  let previousHits;
  let prevNbPages = 1;
  let prevSelectedFiltersNo = 1;
  const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, showPrevious, showMore, results, isFirstPage, isLastPage } = renderOptions;
    const { container } = widgetParams;
    const containerClasses = Array.from(container.classList);
    const isLoaded = containerClasses.find((x) => x == "ais-container--loaded") === undefined;
    const isScrolled = !(results?.page == 0);
    const selectedFiltersNo = document.querySelectorAll(".ais-current-refined-values--link").length;
    const isValidUserData = (userData) => userData && Array.isArray(userData);
    const shouldInjectRecord = (position, start, end) => position > start && position <= end;
    const injectAds = (items) => {
      var results = finalHitsRender?.results;
        try {
            if (results?.userData) {
              Object.keys(results.userData).forEach(function(index){
                const userData = results.userData[index]?.ads;
                if (isValidUserData(userData)) { // Appending custom data at the beginning of the array of results only if it's in the range of the position
                  let start = results.page * results.hitsPerPage + 1;
                  let end = results.page * results.hitsPerPage + results.hitsPerPage;
                  userData.forEach((record) => {
                      var found = false;
                      $.map(items, function(val) {
                        if(val.button != undefined){
                          if (record.button == val.button) found = true;
                        }
                      });
                      if (shouldInjectRecord(record.position, start, end) && !found) {
                        if ($(window).width() < 1024){
                          if (record.width == 2){
                            if (record.position % 2 == 0) items.splice((record.position + 1) - (results.hitsPerPage*results.page) - 1, 0, record);
                            else items.splice(record.position - (results.hitsPerPage*results.page) - 1, 0, record);
                          } else items.splice(record.position - (results.hitsPerPage*results.page) - 1, 0, record);
                        } else {
                          items.splice(record.position - (results.hitsPerPage*results.page) - 1, 0, record);
                        }
                      }
                  });
                }
              });
              // console.log(items, 'items');
            }
        } catch (error) {
            console.log(error);
        }
    };
    const hitsWithAds = (items) => {
        const list = container.querySelector("ol");
        list.innerHTML = "";
        const templates = {
            empty: (results, {html}) => algolia.instantSearchNoResultTemplate(html),
            item: (hit, {html, instantsearch}) => algolia.instantSearchProductTemplate(hit, html, instantsearch),
            injectedItem: (hit, AdsCount, altImg, banner_position, width) => `<div data-promotion-type="gtm-banner" data-hit_width="${width}" data-promotion-name="${banner_position} ${AdsCount} Ghost ad" data-promotion-id="${hit.image}" data-promotion-creative_name="${hit.button}" data-promotion-position="${banner_position}" data-promotion-index="${hit.position}" data-algolia-advert-target="${hit.target}" data-algolia-advert-title="${hit.button}" data-algolia-advert-position="${hit.position}" data-algolia-advert-injected="${hit.injected}" class="ais-hit ais-product ais-advert"><div class="ais-hit--picture product_cart_image_container"><div class="product_slider_img"><div class="product_img_wp"><a href="${hit.target}" title="${hit.button}"><img src="${hit.image}" alt="`+ altImg +`" /></a></div></div></div></div>`,
        };
        var AdsCount = 0
        if (results?.hits?.length == 0) {
          list.innerHTML = templates.empty(results, {html});
          return;
        }
        prevSelectedFiltersNo = selectedFiltersNo;
        list.insertAdjacentHTML(
            "beforeend",
            items.map((hit) => {
              const tags =
                  hit.tags !== undefined
                      ? hit.tags
                          ? typeof hit.tags === "string"
                              ? new Array(1).fill(hit.tags)
                              : hit.tags
                          : []
                      : [];
              const discount_val = 25;
              // const flash_sale = '$'+ parseFloat(hit.price * ((100-discount_val) / 100 )).toFixed(2) + ' with code PARTY';
              // const flash_sale = algolia.formatMoney(parseFloat((hit.price - ((discount_val*hit.price)/100)) * 100))+" with code PARTY";
              const hitPromoMessages = () => {
              const promoTags = [
                    { tag: "limited_stock", message: "LIMITED STOCK" }
                    // ,{ tag: "6DAYSOFDOLCE", message: "Days of Dolce Deal - Prices as Marked" }
                    // ,{ tag: "HOLIDAYFLASH", message: flash_sale }
                    // ,{ tag: "SALE", message: flash_sale }
                    // ,{ tag: "FINAL SALE", message: flash_sale }
                  ];

                if (tags.length > 0 && promoTags.length > 0) {
                  promoTags.forEach((promoTag) => {
                    if (tags.find((x) => x.toUpperCase() == promoTag.tag.toUpperCase())) hit.promoMessage = promoTag.message;
                  });
                }
              };
             if (hit.injected) {
                  hit.title = hit.target.split("/").pop().toUpperCase().replaceAll("-", " ");
                  let width = 0, width_class = '';
                  var banner_position = collectionHandle, altImg = '';
               
                  if (hit.width != undefined) width = hit.width;
                  altImg = (hit.imageAlt != undefined && hit.imageAlt != '') ? hit.imageAlt : hit.button;
                  
                  AdsCount += 1;
                  if (width == 2) width_class = 'two-span';
                  return '<li class="ais-Hits-item '+ width_class+'">'+ templates.injectedItem(hit, AdsCount, altImg, banner_position, width)+'</li>';
              } else {
               if ($('body').attr('data-free_gift') != undefined){ // remove free gift product
                  var free_gift_id = parseInt($('body').attr('data-free_gift'));
                  if (free_gift_id != hit.objectID) return '<li class="ais-Hits-item">'+templates.item(hit, {html, instantsearch})+'</li>';
                } else {
                  hitPromoMessages();
                  return '<li class="ais-Hits-item">'+templates.item(hit, {html, instantsearch})+'</li>';
                }
              }
          }).join("")
        );
    };
    
    previousHitsRender = finalHitsRender ?? undefined;
    previousHits = finalHitsRender?.hits ?? [];
    prevNbPages = finalHitsRender?.results?.nbPages ?? 1;
  
    finalHitsRender = renderOptions;
    injectAds(hits);

    if (isFirstRender) {
      const ul = document.createElement("ol");
      const observeElements = () => {
          const sentinel = document.querySelector("#main-content");
        
          const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                  if (entry.isIntersecting && !finalHitsRender?.isLastPage) {
                      injectAds(finalHitsRender.hits);
                      hitsWithAds(finalHitsRender.hits);
                  }
              });
          });
          observer.observe(sentinel);
      };
      ul.classList.add("ais-Hits-list");
      container.appendChild(ul);
      observeElements();
      return;
    }
  
    container.querySelector("ol").classList.add("ais-Hits-list");
    hitsWithAds(finalHitsRender.hits);
  
    if(finalHitsRender.hits.length == 0){
      $('body').append('<style data_custom_algolia_css>.ais-pagination-container{visibility: hidden; opacity: 0;}</style>');
    }else{
      $('[data_custom_algolia_css]').remove();
    }
    return;
  };
  
  const customHits = instantsearch.connectors.connectHits(renderHits);
  instant.search.addWidgets([
      customHits({
        container: document.querySelector(".ais-hits-container"),
        showPrevious: true,
        transformItems: (products) => {
            return products.map((product) => {
                return algolia.assign({}, product, {
                    _distinct: instant.distinct,
                    can_order:
                        product.inventory_management !== "shopify" ||
                        product.inventory_policy === "continue" ||
                        product.inventory_quantity > 0,
                    translations: algolia.translations,
                    queryID: product.__queryID,
                    productPosition: product.__position,
                    index: instant.search.mainIndex.getIndexName(),
                });
            });
        }
      })
  ]);

  // instant.search.addWidgets([ // Default Hits ALGOLIA CODE
  //   hits({
  //     container: '.ais-hits-container',
  //     templates: {
  //       item(hit, {html, components}) {
  //         return algolia.instantSearchProductTemplate(hit, html, components);
  //       },
  //       empty(results, {html}) {
  //         return algolia.instantSearchNoResultTemplate(html);
  //       }
  //     },
  //     transformItems: function(items) {
  //       return items.map( item => ({
  //         ...item,
  //         _distinct: instant.distinct,
  //         can_order:
  //           item.inventory_management !== 'shopify' ||
  //           item.inventory_policy === 'continue' ||
  //           item.inventory_quantity > 0,
  //         queryID: item.__queryID,
  //         productPosition: item.__position,
  //         index: instant.search.mainIndex.getIndexName()
  //       }));
  //     }
  //   })
  // ]);
  
  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined = helper.state.isConjunctiveFacet(f.name) && helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined = helper.state.isDisjunctiveFacet(f.name) && helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined = helper.state.isHierarchicalFacet(f.name) && helper.state.isHierarchicalFacetRefined(f.name);
      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(operator) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /** Decides whether the given `facetName` has any facet values available in the current result set by checking the available `facets`, `disjunctiveFacets` and `hierarchicalFacets`. */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /** Setup the facets for search. We are using a `panel` with a custom `hidden` function which will allow us to hide the parent container of the facet if there are no facet values available for that particular facet. */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute), 
            displayStyle = hide ? 'none' : '';

        /** Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector can work as expected. "." is supposed to be present for named tags and metafield based facet names and "%" is present when the facet name has a space in it because of the encoding.  */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(widget.params.attribute).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }
        return hide;
      },
    })(widget.widget);

    if (widget.params.attribute === "options.size" || widget.params.attribute === "named_tags.Size") {
      widget.params.limit = 10;
      widget.params.showMore = true;
      widget.params.showMoreLimit = 1000;
      widget.params.operator = "or";
    }

    if (widget.params.attribute === "named_tags.Color") {
      widget.params.limit = 10;
      widget.params.showMore = true;
      widget.params.showMoreLimit = 1000;
      widget.params.operator = "or";
      widget.params.transformItems = (items) => {
        const facets = [];
        const orderedColors = new Set();
        const mappedColors=[
          {color:"Animal",swatch:{image:"https://cdn.shopify.com/s/files/1/0037/3807/5202/t/106/assets/LEOPARD-CALF-HAIR.jpg",color:""}},{color:"Black",swatch:{image:"",color:"#000"}},{color:"Blue",swatch:{image:"",color:"#0000cd"}},{color:"Blush",swatch:{image:"https://cdn.shopify.com/s/files/1/0037/3807/5202/t/106/assets/BLUSH-MULTI-PEARLS.jpg?v=136171958782955459791652247825",color:""}},{color:"Brown",swatch:{image:"",color:"#8b4513"}},{color:"Green",swatch:{image:"",color:"#bbba6a"}},{color:"Grey",swatch:{image:"",color:"#808080"}},{color:"Metallic",swatch:{image:"https://cdn.shopify.com/s/files/1/0037/3807/5202/t/106/assets/SILVER-METALLIC-SUEDE.jpg?v=25653262897961685081652248181",color:""}},{color:"Pink",swatch:{image:"",color:"#ff69b4"}},{color:"Prints",swatch:{image:"https://cdn.shopify.com/s/files/1/0037/3807/5202/t/106/assets/OFF-WHITE-EMBOSSED-LEATHER.jpg?v=105938370552273490241652248101",color:""}},{color:"Purple",swatch:{image:"",color:"#9400d3"}},{color:"Red",swatch:{image:"",color:"#ff0000"}},{color:"Tan",swatch:{image:"",color:"#d2b48c"}},{color:"Taupe",swatch:{image:"",color:"#483c32"}},{color:"White",swatch:{image:"",color:"#ffffff"}},{color:"Yellow",swatch:{image:"",color:"#ffff00"}}
        ];
        mappedColors.forEach((mappedColor) => {
          let color = items.find((x) => capitalizeText(x.label) == mappedColor.color);
          if (color) {
            orderedColors.add(color);
          }
        });
        orderedColors.forEach((color) => {
          const newColor = color;
          const mappedColor = mappedColors.find((x) => x.color == capitalizeText(newColor.label));
          newColor.label = capitalizeText(newColor.label);
          if (mappedColor !== undefined) {
            newColor.swatch = {};
            newColor.swatch.color = mappedColor.swatch.color;
            newColor.swatch.image = mappedColor.swatch.image;
          }
          facets.push(newColor);
        });
        return facets;
      };
    }
   if (widget.params.attribute === "options.color" ) {
      widget.params.limit = 10;
      widget.params.showMore = true;
      widget.params.showMoreLimit = 1000;
      widget.params.operator = "or";
      widget.params.transformItems = (items) => {
        const facets = [];
        const orderedColors = new Set();
        var all_swatch = 'AGAVE,ALMOND,ALMOND STELLA SUEDE,ALMOND SUEDE,ANTHRACITE SUEDE,APRICOT STELLA,B W SNAKE PRINT LEATHER,BEIGE LEOPARD CANVAS,BEIGE MULTI STELLA,BEIGE PATENT STELLA,BEIGE PATENT STELLA H2O,BEIGE SILK,BEIGE STELLA,BLACK,BLACK EMBOSSED LEATHER,BLACK EMBOSSED LIZARD,BLACK EMBOSSED STELLA,BLACK FABRIC,BLACK LEATHER,BLACK LEATHER H2O,BLACK MESH,BLACK MULTI,BLACK MULTI LEATHER,BLACK NATURAL RAFFIA,BLACK NUBUCK,BLACK NYLON,BLACK PATENT STELLA,BLACK PATENT STELLA H2O,BLACK PINK,BLACK PINK LEATHER H2O,BLACK RAFFIA,BLACK RHINESTONE,BLACK SPOTTED CALF HAIR,BLACK STELLA,BLACK STELLA SUEDE,BLACK SUEDE,BLACK WHITE LEATHER,BLACK WHITE STRIPE FABRIC,BLACK WOVEN,BLUE TIE DYE STELLA,BLUSH LEATHER,BLUSH MULTI PEARLS,BLUSH MULTI VINYL,BLUSH STELLA,BLUSH SUEDE,BONE LEATHER,BONE MULTI EMBOSSED STELLA,BONE PATENT STELLA,BONE SNAKE PRINT LEATHER,BRANDY SUEDE,BROWN,BROWN MULTI LEATHER,BROWN MULTI STELLA,BROWN NUBUCK,BROWN STELLA,BROWN SUEDE,BROWN SUEDE H2O,CAFE,CAFE CANVAS,CAFE EMBOSSED LEATHER,CAFE EMBOSSED STELLA,CAFE LEATHER,CAFE MULTI STELLA,CAFE NUBUCK,CAFE PATENT,CAFE SILK,CAFE STELLA,CAMEL FELT,CAMEL NUBUCK,CAMEL SUEDE,CARAMEL LEATHER,CARAMEL MULTI LEATHER,CARAMEL STELLA,CASHEW STELLA SUEDE,CEDAR EMBOSSED STELLA,CEDAR LEATHER,CEDAR NUBUCK,CEDAR STELLA,CHARCOAL SUEDE,CHARCOAL SUEDE H2O,CHOCOLATE LEATHER,CITRON,COGNAC,COGNAC CROCO,COGNAC MULTI COBRA SPOTTED STELLA,COGNAC SUEDE,CONCRETE GREY SUEDE,COPPER MULTI STELLA,CORAL MULTI STELLA SUEDE,CORAL PATENT STELLA,CORK,CORK STELLA,CREAM EMBOSSED STELLA,CREAM LEATHER,CREAM LEOPARD PRINT SUEDE,CREAM MULTI EMBOSSED LEATHER,CREAM STELLA,CRYSTAL RHINESTONE,CRYSTAL VINYL,DAFFODIL STELLA,DARK GOLD,DARK GREY SUEDE,DARK LEOPARD,DESERT ROSE,DK BLUE DENIM,DK BROWN LEATHER,DK BROWN NUBUCK,DK BROWN SUEDE,DK BROWN SUEDE H2O,DK LEOPARD PATENT STELLA,DK LEOPARD STELLA SUEDE,DK LEOPARD SUEDE,DK TAUPE,DK TAUPE SUEDE,DOVE NUBUCK,DUNE EMBOSSED LEATHER,DUNE MULTI SUEDE,DUNE NUBUCK,DUNE SUEDE,DUNE SUEDE H2O,Dune Leather,ELECTRIC BLUE CRACKLED STELLA,ELECTRIC BLUE LEATHER,ELECTRIC BLUE STELLA,ELECTRIC PINK CRACKLED STELLA,ELECTRIC PINK LEATHER,ELECTRIC PINK STELLA,ELECTRIC VIOLET LEATHER,ESPRESSO STELLA,ESPRESSO SUEDE,FAWN CALF HAIR,FOG SUEDE H2O,FUCHSIA STELLA,GOLD CRACKLED STELLA,GOLD METALLIC LEATHER,GOLD METALLIC STELLA,GOLD METALLIC STELLA SUEDE,GOLD MULTI,GOLD MULTI CALF HAIR,GOLD MULTI LEATHER,GOLD STELLA,GREEN LEATHER,GREEN METALLIC LEATHER,GREEN NUBUCK,GREY FELT,GREY SUEDE,Gray,HONEY SUEDE,INDIGO SILK,IVORY,IVORY CANVAS,IVORY CROCO PRINT LEATHER,IVORY EMBOSSED LEATHER,IVORY EMBOSSED STELLA,IVORY LEATHER,IVORY LEATHER H2O,IVORY MULTI EMBOSSED LEATHER,IVORY MULTI LEATHER,IVORY MULTI STELLA,IVORY NUBUCK,IVORY PATENT STELLA,IVORY PATENT STELLA H2O,IVORY RAFFIA,IVORY ROPE,IVORY STELLA,IVORYIVORY MULTI STELLA,JADE PLUSH,KHAKI SILK,LAVENDER STELLA,LEOPARD,LEOPARD CALF HAIR,LEOPARD FABRIC,LEOPARD MULTI CALF HAIR,LEOPARD STELLA SUEDE,LIGHT BLUE,LIGHT GOLD CRACKLED STELLA,LIGHT GOLD LEATHER,LIGHT GOLD MESH,LIGHT GOLD METALLIC STELLA,LIGHT GOLD METALLIC STELLA SUEDE,LIGHT GOLD METALLIC SUEDE,LIGHT GOLD STELLA,LIGHT GREEN LEATHER,LIGHT GREEN STELLA,LIGHT GREY RAFFIA,LILAC LEATHER,LILAC RAFFIA,LILAC STELLA,LT BLUSH LEATHER,LT BLUSH MESH,LT BLUSH STELLA,LT LUGGAGE LEATHER,LT NATURAL RAFFIA,LT TAUPE EMBOSSED STELLA,LUGGAGE EMBOSSED STELLA,LUGGAGE STELLA,MANGO,MANGO SNAKE PRINT STELLA,MERCURY LEATHER,MERCURY METALLIC STELLA,METALLIC MULTI STELLA,METALLIC MULTI STELLA SUEDE,MIDNIGHT CALF HAIR,MIDNIGHT PATENT STELLA,MINT MULTI EMBOSSED LEATHER,MINT MULTI SNAKE PRINT LEATHER,MINT MULTI STELLA,MINT RAFFIA,MINT ROPE,MOCHA CANVAS,MOCHA LEATHER,MOSS NUBUCK,MUSHROOM,MUSHROOM NUBUCK,MUSHROOM STELLA SUEDE,MUSHROOM SUEDE,MUSTARD,Multi,NATURAL CORK,NATURAL FABRIC,NATURAL LEATHER,NATURAL LINEN,NATURAL MULTI LEATHER,NATURAL MULTI LINEN,NATURAL MULTI STELLA,NATURAL PLUSH,NATURAL RAFFIA,NATURAL SUEDE,NATURAL WHITE,NATURAL WHITE STELLA,NOIR CROCO PRINT STELLA,NOIR EMBOSSED STELLA,NUDE CRYSTAL,OFF WHITE,OFF WHITE EMBOSSED LEATHER,OFF WHITE LEATHER,OFF WHITE LEATHER H2O,OFF WHITE NYLON,OFF WHITE STELLA,OLIVE,OLIVE LEATHER,OLIVE MULTI NYLON,OLIVE STELLA,ONYX,ONYX LEATHER,ONYX LEATHER H2O,ONYX NUBUCK,ONYX PATENT,ONYX PATENT STELLA,ONYX STELLA,ONYX SUEDE,PERSIMMON LEATHER,PERSIMMON STELLA,PERSIMMON SUEDE,PETAL PINK STELLA,PEWTER STELLA,PEWTER STELLA SUEDE,PINK METALLIC LEATHER,PINK MULTI EMBOSSED LEATHER,PINK RAFFIA,PISTACHIO LEATHER,PISTACHIO STELLA,PRALINE NUBUCK,PRALINE SUEDE,RED LEATHER,RED ORANGE LEATHER,ROSE GOLD EMBOSSED LEATHER,ROSE GOLD LEATHER,ROSE GOLD METALLIC STELLA,ROSE GOLD STELLA,ROSE LEATHER,ROSE MULTI STELLA,ROSE NUBUCK,ROSE PATENT STELLA,ROSE STELLA,ROSE SUEDE,RUST CALF HAIR,SADDLE LEATHER,SADDLE SUEDE,SAGE CANVAS,SAGE STELLA,SAGE SUEDE,SAND LEATHER,SAND NUBUCK,SAND PLUSH,SANDSTONE CANVAS,SILVER,SILVER CRACKLED STELLA,SILVER GOLD METALLIC CALF HAIR,SILVER GOLD STELLA SUEDE,SILVER IRIDESCENT STELLA,SILVER IRIDESCENT VINYL,SILVER LEATHER,SILVER MESH,SILVER METALLIC CALF HAIR,SILVER METALLIC STELLA,SILVER METALLIC STELLA SUEDE,SILVER METALLIC SUEDE,SILVER MULTI CALF HAIR,SILVER STELLA,SKY BLUE STELLA,SKYBLUE STELLA,SMOKE SUEDE,STONE MULTI LEATHER,STONE SNAKE PRINT LEATHER,TAN,TAN LEATHER,TAN MULTI FABRIC,TAN MULTI NYLON,TAN MULTI SNAKE PRINT,TAN MULTI STELLA,TAN STELLA,TAUPE EMBOSSED STELLA,TAUPE LEATHER,TAUPE MULTI SUEDE,TAUPE PATENT STELLA,TAUPE SUEDE,TOBACCO CROCO PRINT STELLA,TORTOISE,TORTOISE MULTI VINYL,TORTOISE VINYL,TRUFFLE STELLA SUEDE,TRUFFLE SUEDE,TRUFFLE SUEDE H2O,VANILLA LEATHER,VANILLA NUBUCK,VANILLA PEARLS,VANILLA RAFFIA,VANILLA ROPE,VANILLA STELLA,VANILLA STUDDED LEATHER,VANILLA WOVEN,WHEAT RAFFIA,WHISKEY NUBUCK,WHITE BLACK LEATHER,WHITE CANVAS,WHITE EMBOSSED LEATHER,WHITE GREEN,WHITE GREEN LEATHER H2O,WHITE LEATHER,WHITE MESH,WHITE MULTI STUDDED LEATHER,WHITE PERFORATED LEATHER,WHITE STELLA,WHITE STRIPE FABRIC,White,YELLOW LEATHER,YELLOW PATENT STELLA,YELLOW STELLA'
        var allColors = [],jsonObj = [];
        var nameArr = all_swatch.split(',');
          for (i = 1; i <= nameArr.length ; i++ ){
            allColors = {};
            var swatch = {};
            if (nameArr[i] != undefined || nameArr[i] != null ){
              allColors ["color"] = titleCase(nameArr[i]);
              swatch ["image"] = 'https://cdn.shopify.com/s/files/1/0037/3807/5202/t/106/assets/'+nameArr[i].replace(/\s+/g, '-')+'.jpg?v=10515990655290616900165224823'+i;
              swatch ["color"] = "";
              allColors ["swatch"] = swatch;
            }
            jsonObj.push(allColors);
          }
        const mappedColors = JSON.stringify(jsonObj);
        var obj = jQuery.parseJSON(mappedColors);
        $.each(obj, function(key,mappedColor) {
          let color = items.find((x) => capitalizeText(x.label) == mappedColor.color);
          if (color) {
            orderedColors.add(color);
          }
        });
        orderedColors.forEach((color) => {
          const newColor = color;
          const mappedColor = obj.find((x) => x.color == capitalizeText(newColor.label));
          newColor.label = capitalizeText(newColor.label);
          if (mappedColor !== undefined) {
            newColor.swatch = {};
            newColor.swatch.color = mappedColor.swatch.color;
            newColor.swatch.image = mappedColor.swatch.image;
          }
          facets.push(newColor);
        });
        set_color_op();
        return facets;
      };
    }
    
    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });
  
  instant.search.addWidgets([ // Redirect to product on click
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target, hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) return;
          
          var $this = hit, 
              productHandle = $this.dataset.handle,
              variant_id = $this.dataset.variantId,
              distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';
          if (collectionPageEnabled && collectionHandle) { // If we're on a collection page and the handle is available then prefix the product link with the collection handle
            link = `${window.Shopify.routes.root}collections/${collectionHandle}`;
          }
          link = link + `${window.Shopify.routes.root}products/${productHandle}`; // Add the product handle to the link
          if (distinct !== 'true') { // Add the variant ID details to redirect to a specific variant ID if we are showing variants and not products
            link += '?variant=' + variant_id; 
          }

          if (algolia.config.analytics_enabled) {
            const clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };
            // Init function before sending
            aa.init({
              appId: algolia.config.app_id,
              apiKey: algolia.config.search_api_key,
            });
            aa.clickedObjectIDsAfterSearch(clickData); // Send the click event
            algolia.saveForConversionTracking(clickData); /** Uncomment the following function call to start storing data in local storage for conversion tracking */
            localStorage.getItem('algolia_analytics_clicked_objects') // analytics data stored here.
          }
           if (GTM_ANALYTICS_ENABLED) { // Initialize the GTM data layer
              window.dataLayer = window.dataLayer || [];
              if (window.dataLayerData) { // GTM Data for Advert
                let productData = finalHitsRender.hits.find((x) => x.objectID == hit.dataset.algoliaObjectid);
                window.dataLayerData = {
                    event: "productClick",
                    product: createDataLayerProduct(productData),
                };
                window.dataLayer.push(window.dataLayerData);
              }
          }
        });
      },
    },
  ]);
  
  instant.search.addWidgets([ // Add to cart
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target,
              cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) return;

          e.stopPropagation();
          var $this = cartButton,
              formId = $this.dataset.formId;

          if (formId) document.getElementById(formId).submit();
        });
      },
    },
  ]);
  
  instant.search.addWidgets([ // No result actions
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target, clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) return;

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target, clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) return;

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  instant.search.addWidgets([ // Pagination
    pagination({
      container: '.ais-pagination-container',
      padding: 2,
      maxPages: 20,
    }),
  ]);

  const connectPriceRange = algolia.externals.connectors.connectRange; // Price filter
  const renderPriceRange = (renderOptions, isFirstRender) => {
      const { refine, range, start, formatter, widgetParams } = renderOptions;
      const container = document.querySelector(widgetParams.container);
      set_price_cur();
  };
  const customPriceRange = connectPriceRange(renderPriceRange);
  instant.search.addWidgets([
      customPriceRange({
          container: '[class~="ais-facet-price-container"]',
          attribute: "price",
      }),
  ]);

  let pageFiltered = false;
  let prevFiltersNo = 0;
  let prevViewMoreSegment = [];
  let loadEventDisplayed = false; 
  instant.search.start(); // Main
  let cnt_load = 0;
  instant.search.on("render", () => {
    cnt_load++;
    const updateGTMDataLayer = () => {
      if (!GTM_ANALYTICS_ENABLED) return; 
      const SHOW_EVENTS = true;
      const container = finalHitsRender?.widgetParams.container;
      const results = finalHitsRender?.results; // Ghost ads datalayer
      const products = finalHitsRender?.hits;

      const sort = document.querySelector(".ais-sort select");
      const query = document.querySelector(".ais-search-query--term").innerHTML != '' ? document.querySelector(".ais-search-query--term").innerHTML : window.location.href.split('?q=')[1];
      const clearFiltersBtn = document.querySelector(".ais-ClearRefinements-button");
      const clearFilters = document.querySelectorAll(".ais-current-refined-values--item");
      const dataLayerProducts = [];
      
      const all_datalayer = (pageFiltered, prevFiltersNo) => {
        if (pageFiltered && clearFilters.length !== prevFiltersNo) {
          if (window.dataLayerData && dataLayerProducts.length > 0) {
              let url = window.location.href;
              let mappedFilters = {
                "options.size": "size","options.color": "color","named_tags.Color": "color","named_tags.Type": "type","named_tags.Style": "style","named_tags.Brand": "brand","named_tags.Height": "height","price": "price",
              };
              let lastRefinedValue = document.querySelector(".ais-current-refined-values--list li:last-of-type a");
              let filterName = lastRefinedValue.dataset.attribute;
              let filterValue = lastRefinedValue.dataset.value;
              let isSearch = ~url.indexOf("/search");
              let resultsNo = isSearch ? algolia.config.products_full_results_hits_per_page : algolia.config.collections_full_results_hits_per_page;
              let pushFilterData = (products) => {
                  window.dataLayerData = {
                      event: "filter",
                      filterName: mappedFilters[filterName],
                      filterValue: filterValue,
                      productList: {
                          products: products,
                      },
                      _clear: true,
                  };
                var filter_all_datalayers = window.dataLayer.filter((obj) =>  obj.event == 'filter');
                var push_filter = true;
                if (push_filter == true || filter_all_datalayers.length == 0){ 
                  if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)), 'updateGTMDataLayer 1' );
                  window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
                }
              };
              setTimeout(() => {
                  if (finalHitsRender?.results?.page > 0) {
                      let value = finalHitsRender?.results?.page + 1;
                      setTimeout(() => {
                          if (Math.round(finalHitsRender.hits.length / resultsNo) == value) {
                              let newDataLayerProducts = [];
                              finalHitsRender.hits.forEach((product) => {
                                  if (product.injected === undefined) {
                                      if (product.shopTheLook === undefined || product.shopTheLook_reg === undefined) {
                                          newDataLayerProducts.push(createDataLayerProduct(product));
                                      }
                                  }
                              });
                              pushFilterData(newDataLayerProducts);
                          }
                      }, 1000);
                  } else {
                      let newDataLayerProducts = [];
                      finalHitsRender.hits.forEach((product) => {
                          if (product.injected === undefined) {
                              if (product.shopTheLook === undefined || product.shopTheLook_reg === undefined) {
                                  newDataLayerProducts.push(createDataLayerProduct(product));
                              }
                          }
                      });
                      pushFilterData(newDataLayerProducts);
                  }
              }, 1000);
          }
          prevFiltersNo = clearFilters.length != prevFiltersNo ? clearFilters.length : prevFiltersNo;
          return;
      }
        if (window.dataLayerData && dataLayerProducts.length > 0) {
          let isSearch = ~url.indexOf("/search");
          let isCollection = ~url.indexOf("/collections");
          let resultsNo = isSearch ? algolia.config.products_full_results_hits_per_page : algolia.config.collections_full_results_hits_per_page;
          if (isSearch && dataLayerProducts.length <= resultsNo && !loadEventDisplayed) {
              window.dataLayerData = {
                  event: "search",
                  searchTerm: query,
                  productList: {
                      products: dataLayerProducts,
                  },
                  _clear: true,
              };
              if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)), 'updateGTMDataLayer 2' );
              window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
        } else if (isCollection && dataLayerProducts.length <= resultsNo && !loadEventDisplayed) {
              window.dataLayerData = {
                  event: "product list displayed",
                  productList: {
                      name: query,
                      products: dataLayerProducts,
                  },
                  _clear: true,
              };
              if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)), 'updateGTMDataLayer 3' );
              window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
        } else if ((isCollection || isSearch) && (window.dataLayerData?.event !== "sort" || window.dataLayerData?.event !== "filter") && finalHitsRender?.results?.page > 0) { 
              let slicedProducts = dataLayerProducts.slice(dataLayerProducts.length - resultsNo, dataLayerProducts.length);
                if (prevViewMoreSegment.length == 0) {
                    prevViewMoreSegment = dataLayerProducts;
                    window.dataLayerData = {
                        event: "view more products",
                        productList: {
                            name: query,
                            products: slicedProducts,
                        },
                        _clear: true,
                    };
                    if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)), 'updateGTMDataLayer 4' );
                    window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
                } else {
                  setTimeout(() => {
                      if (slicedProducts[0].id !== prevViewMoreSegment[0].id) {
                          prevViewMoreSegment = [...slicedProducts];
                          window.dataLayerData = {
                              event: "view more products",
                              productList: {
                                  name: query,
                                  products: slicedProducts,
                              },
                              _clear: true,
                          };
                          if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)), 'updateGTMDataLayer 5' );
                          window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
                      }
                  }, 1000);
                }
            }
         }
      }
              
    let url = window.location.href;
    var count = 0;
    if(typeof products !== 'undefined'){
      products.forEach((product) => {
        if (product.injected == undefined) dataLayerProducts.push(createDataLayerProduct(product))
        count++;
        if(count == products.length){
          pageFiltered = !(clearFiltersBtn?.disabled && clearFilters.length == 0) ?? false;
          if ((clearFiltersBtn?.disabled && clearFilters.length == 0)) prevFiltersNo = 0;
          all_datalayer(pageFiltered, prevFiltersNo);
        }
      }); 
    }
    sort?.addEventListener("change", (event) => { // Control the change event to fire once
        if (event.handled !== true) { 
          event.handled = true;
              const sortedProducts = products;
              const sortType = event.target.querySelector(`option[value="${event.target.value}"]`).innerHTML;
              let sortedProductsJSON = [];
              sortedProducts.forEach((product) => {
                  sortedProductsJSON.push(createDataLayerProduct(product));
              });
              window.dataLayerData = {
                  event: "sort",
                  sortType: sortType,
                  productList: {
                      products: sortedProductsJSON,
                  }, 
              };
              if (SHOW_EVENTS) console.log(JSON.parse(JSON.stringify(window.dataLayerData)));
              window.dataLayer.push(JSON.parse(JSON.stringify(window.dataLayerData)));
          return;
        }
    });
      cnt_load = 0; 
      loadEventDisplayed = true; 
    };

    
    if(cnt_load == 3){ updateGTMDataLayer(); //uodateAdsClass(); 
    }
    // ABBagdeTextRun();
  });
  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
